import React from 'react';
import * as Ons from 'react-onsenui';
import Game from '../ListItems/Game';
import PullHook from '../PullHook';
import Toolbar from '../Toolbar';
import { translate as _ } from '../../util/i18n';
import { expired, getWeekday } from '../../util';

class Games extends React.Component {

    #pullHookCallback;

    constructor( props ) {

        // console.log( 'components.Pages.Games.constructor()', props );

        super( props );

        this.state = {
            pullHook: 'initial'
        };

        this.handleBackClick      = this.handleBackClick.bind( this );
        this.handlePullHookChange = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad   = this.handlePullHookLoad.bind( this );
        this.handleSelectGame     = this.handleSelectGame.bind( this );
        this.loadGames            = this.loadGames.bind( this );

    }

    componentDidMount() {

        expired( this.props.lastUpdate ) && this.loadGames();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            const cb = this.#pullHookCallback;

            setTimeout( () => cb(), 1000 );

            this.#pullHookCallback = null;

        }

    }

    handleBackClick() {

        this.props.onChangePage( { page: 'seasons' } );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.loadGames();

    }

    handleSelectGame( game ) {

        this.props.onSelectGame( game );
        this.props.onChangePage( { page: 'game' } );

    }

    loadGames() {

        this.props.onLoadGames( this.props.context, this.props.token, this.props.activeSeason.id );

    }

    render() {

        const gamesByDate = {};

        if ( this.props.games && this.props.games.length ) {

            this.props.games.forEach( game => {

                const gameDate = game.dateIsToBeDetermined ? _( 'TBD' ) : ( getWeekday( new Date( game.scheduledDate.sortValue ) ) + ', ' + game.scheduledDate.shortValue );

                if ( ! ( gameDate in gamesByDate ) ) {

                    gamesByDate[ gameDate ] = {
                        games: [],
                        sort:  game.dateIsToBeDetermined ? Number.MAX_SAFE_INTEGER : game.scheduledDate.sortValue
                    };

                }

                gamesByDate[ gameDate ].games.push( game );

            } );

        }

        const gamesByDateEntries = Object.entries( gamesByDate );

        gamesByDateEntries.sort( ( a, b ) => a[ 1 ].sort - b[ 1 ].sort );

        return (

            <Ons.Page renderToolbar={() => <Toolbar title={_( 'Spiele' )} onBackClick={this.handleBackClick} onMenuClick={this.props.onMenuClick} onReloadClick={this.loadGames} />}>

                <PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad} />

                {this.props.loading && this.state.pullHook !== 'action' && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                <h1 className="page-title">{_( 'Spiele' )}</h1>

                {
                    gamesByDateEntries.length ?

                        // TODO remove Math.random() from key (currently needed because multiple games have id 0000-0000-0000-0000)

                        gamesByDateEntries.map( ( [ gameDate, games ] ) => {

                            return <Ons.List
                                dataSource={games.games}
                                key={gameDate}
                                renderHeader={() => <Ons.ListHeader>{gameDate}</Ons.ListHeader>}
                                renderRow={( game, idx ) =>
                                    <Game
                                        context={this.props.context}
                                        game={game}
                                        key={game.id + Math.random()}
                                        modifier={idx === this.props.games.length - 1 ? 'longdivider' : null}
                                        onClick={this.handleSelectGame}
                                    />
                                }
                            />;

                        } )

                    : ! expired( this.props.lastUpdate ) &&

                        <div className="no-items">
                            <p>{_( 'Keine Spiele gefunden.' )}</p>
                            <Ons.Button modifier="large" onClick={this.loadGames}>{_( 'Aktualisieren' )}</Ons.Button>
                        </div>
                }

            </Ons.Page>

        );

    }

}

export default Games;